import Swal from "sweetalert2";
import { MAIN_COLOR } from "./constant";
import { authFetch, authFileFetch } from "./fetchUtils";
import { ApiEndpoint } from "../../env.config";
import moment from "moment";
import Papa from "papaparse";

// #region 共通処理関数群
/**
 * arrayの完全一致
 * @param {*} array1
 * @param {*} array2
 * @returns {boolean}
 */
export const compareArray = (array1, array2) => {
  return array1.length === array2.length && array1.every((value, index) => value === array2[index]);
}

/**
 * Objectの完全一致
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */
export const compareObject = (obj1, obj2) => {
  return isNull(obj1) && isNull(obj2) && JSON.stringify(obj1) === JSON.stringify(obj2);
}

/**
 * Null判定(undefined包含)
 * @param {*} value
 * @returns {boolean}
 */
export const isNull = (value) => {
  return value === undefined || value === null;
}

/**
 * Empty判定(null, undedinedもtrueとみなす)
 * @returns {boolean}
 */
export const isNullOrEmpty = (value) => {
  return isNull(value) || value === "";
}

/**
 * 文字列取得(デフォルト値付き)
 * @param {*} aStr 入力文字列
 * @param {*} aDefault null or undefined時のデフォルト値  default: 空文字("")
 * @returns
 */
export const getString = (aStr, aDefault = "") => {
  return isNull(aStr) ? aDefault : aStr;
}

/**
 * Array判定
 * @param {any} value
 * @returns {boolean}
 */
export const isArray = (value) => {
  return value instanceof Array;
}

/**
 * Array 且つ 要素数1以上 判定
 * @param {*} value
 * @returns
 */
export const isArrayMoreOne = (value) => {
  return isArray(value) && value.length > 0;
}

/**
 * 0埋め処理
 * @param {string} aNumStr 数値文字列
 * @param {number} aLength 0埋めの長さ(Integer)
 * @returns
 */
export const zeroPadding = (aNumStr, aLength) => {
  return ("0".repeat(aLength) + aNumStr).slice(-aLength);
}
// #endregion

export const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  animation: false,
  timer: 3000,
});

export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
    Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
};

export const coordinateToDistance = (points) => {
  var result = 0;
  var lastPoint = points[0];
  for (let i = 1; i < points.length; i++) {
    const point = points[i];
    result += getDistanceFromLatLonInKm(
      lastPoint[0],
      lastPoint[1],
      point[0],
      point[1]
    );
    lastPoint = point;
  }

  return result;
};

export const runSnapToRoad = (finalArray) => {
  return "";
};

export const groupBy = (xs, key) => {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const getUnique = (array) => {
  var uniqueArray = [];
  for (var i = 0; i < array.length; i++) {
    if (uniqueArray.indexOf(array[i]) === -1) {
      uniqueArray.push(array[i]);
    }
  }
  return uniqueArray;
};

/**
 * (Surface Condition)入力値(aValue)について色分けルール(aRules)に基づいた色情報(#FFFFFF型式)を取得する
 * @param {*} aValue distress値
 * @param {*} aRules 色分けルール配列
 * @returns
 */
export const getColorByDistress = (aValue, aRules) => {
  const condition = (aRules || []).find((x) => x.value == aValue);
  if (condition) {
    return condition.color;
  }
  return MAIN_COLOR;
};

/**
 * 調査データからGeoJSON（featureCollectionのfeatures部分）を構築する（SHPダウンロード用）
 * →現在未使用
 * @param {string} userId ユーザID
 * @param {array} rulesSurfaceCondition Surface Conditionの色分け条件情報
 * @param {array} surveyedData 調査データ
 * @param {string} surveyedMapType point or line
 * @returns {array} featureCollectionのfeatures部配列
 */
export const getGeoJsonFromSurveyedData = async (
  userId,
  rulesSurfaceCondition,
  surveyedData,
  surveyedMapType
) => {
  return new Promise(async (resolve, reject) => {
    // CSVダウンロード(データはファイルの中身がblobで返ってくるという想定？)
    const lat = surveyedData[0].polylines[0][1];
    const lng = surveyedData[0].polylines[0][0];
    const date = moment(surveyedData[0].surveyedDate, "YYYY-MM-DD").format("DDMMYYYY");

    const response = await authFileFetch(
      `${ApiEndpoint}/Road/surveyed/filepath?userId=${userId}&date=${date}&lat=${lat}&lng=${lng}`,
      { method: "GET" }
    );

    // CSV読込
    Papa.parse(await response.blob(), {
      header: true,
      skipEmptyLines: true,
      complete: (parsedData) => {
        const headers = parsedData.data?.length
          ? Object.keys(parsedData.data[0])
          : null;
        // polylineデータが存在するもののみを抽出(長さ2以上)
        const sourceData = surveyedData.filter((x) => Array.isArray(x.polylines) && x.polylines.length > 1);

        // 調査データとcsvを紐づけるための連想配列作成(TODO: kp修正対象箇所)
        const dataInfo = {};
        if (parsedData.data?.length > 0) {
          parsedData.data.forEach((x) => {
            dataInfo[x.picPath] = x;
          });
        }

        let result = [];
        if (surveyedMapType === "line") {
          // - lineの場合
          result = sourceData.map((x) => {
            // 調査データに追加するデータをcsvから特定する
            const additionalData = {};
            // ヘッダなしCSVの場合は結合なし
            // TODO picPathをkeyとして結合objectを作成 -> key基準に変更
            if (Array.isArray(headers)) {
              headers.forEach((columnName) => {
                const attrName = columnName.replaceAll(" ", "_").replaceAll(".", "_").replaceAll("-", "_"); // 名称置換(" .-"->"_"へ共通変換)

                let value = "";
                if (!isNull(x.picPaths)) {
                  // picPathsの
                  value = JSON.stringify(
                    x.picPaths.slice().map((key) => {
                      const tmpKey = key.substring(key.lastIndexOf("/") + 1); // ファイル名の切り出し(ex. ～.jpg)
                      return dataInfo[tmpKey]?.[columnName];
                    })
                  );
                }
                additionalData[attrName] = value;
              });
            }
            const properties = {
              uId: x.userId,
              Date: x.surveyedDate,
              Distress: x.distressAverage,
              Start: `${x.polylines[0][1]} - ${x.polylines[0][0]}`,
              End: `${x.polylines[
                x.polylines.length - 1
              ][1]
                } - ${x.polylines[
                x.polylines.length - 1
                ][0]
                }`,
              color: `${getColorByDistress(x.distressAverage, rulesSurfaceCondition)}`,
              st_name: x.routeName,
              picPaths: x.picPaths ? JSON.stringify(x.picPaths.slice().map(key => `${key.substring(key.lastIndexOf("/") + 1)}`)) : "",
              ...additionalData,
            };

            return {
              type: "Feature",
              geometry: {
                type: "LineString",
                coordinates: x.polylines.slice().map((p) => [p[0], p[1]]),
              },
              properties: properties,
            };
          });
        } else {
          // - pointの場合
          sourceData.map((x) => {
            // ポイント出力にcsvファイルの内容を追加
            // var additionalData = {};
            // if (headers) {
            //   var keys = x.picPaths.slice().filter((x) => x);
            //   headers.map((propName) => {
            //     keys.map((key) => {
            //       if (!additionalData[key]) {
            //         additionalData[key] = {};
            //       }
            //       additionalData[key][
            //         propName
            //           .replaceAll(" ", "_")
            //           .replaceAll(".", "_")
            //           .replaceAll("-", "_")
            //       ] =
            //         dataInfo[`${key.substring(key.lastIndexOf("/") + 1)}`]?.[
            //         `${propName}`
            //         ];
            //     });
            //   });
            // }
            // polylinesから点情報を作成
            x.polylines.slice().forEach((p, idx) => {
              const existingPoint = result.find(
                (x) =>
                  x.geometry.coordinates[0] == p[0] &&
                  x.geometry.coordinates[1] == p[1]
              ); // 点の完全一致確認(座標基準)

              if (!isNull(existingPoint)) return;

              const picPath = x.picPaths && x.picPaths.length > idx ? x.picPaths[idx] : ""; // picPathsの配列と点群はidxで一致させる
              const pointDistress = x.polylineDistress.find(
                (d) => d.polylines === JSON.stringify([p[1], p[0]])
              );
              const distressAverage = pointDistress?.distressAverage || x.distressAverage;
              const fileName = picPath ? picPath.substring(picPath.lastIndexOf("/") + 1) : ""
              result.push({
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [p[0], p[1]],
                },
                properties: {
                  uId: x.userId,
                  Date: x.surveyedDate,
                  DistressAverage: distressAverage,
                  Lat: `${p[1]}`,
                  Long: `${p[0]}`,
                  st_name: x.routeName,
                  picPath: fileName,
                  color: `${getColorByDistress(distressAverage, rulesSurfaceCondition)}`,
                  // ...(additionalData && additionalData[picPath]
                  //   ? additionalData[picPath]
                  //   : {}),
                },
              });
            });
          });
        }
        resolve(result);
      },
      error: (err) => {
        reject(err);
      },
    });
  });
};

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export const HasPermissions = (menuType, permissionType) => {
  const permissionsObj = JSON.parse(
    sessionStorage.getItem("userLogged")
  ).permissions;

  if (!permissionsObj) return false;
  const menuPermission = permissionsObj.find((x) => x.id === menuType.value);

  return menuPermission && menuPermission.permissionTypes
    ? menuPermission.permissionTypes.includes(permissionType?.name)
    : false;
};

/**
 * アップロードする調査年度のチェック
 * @param {*} aUserId
 * @param {*} aYear
 * @returns
 */
export const checkSurveyedYear = async (aUserId, aYear) => {
  const dpYears = await authFetch(`${ApiEndpoint}/Road/yearsslider?userId=${aUserId}`, {
    method: "GET",
  }).then((json) => {
    return json;
  });

  let allowYear = 1900; // アップデート可能な最古年
  // TODO 調査リスト画面でリロードした場合にdpYearsは空になり、チェックが出来ない状態
  for (const d of dpYears) {
    // 過去のActualデータは更新不可
    if ((d.isActual === true && d.isPredict === true) || (d.isActual === true && d.isPredict === false) || (isNullOrEmpty(d.isActual) && d.isPredict === true)) {
      allowYear = Number(d.year);
    }
  }
  return (Number(aYear) >= allowYear);
}
